function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.2 298.7c-8.9 0-16.2-9-16.2-20.2V127.4c0-11.1 7.2-20.2 16.2-20.2 8.9 0 16.2 9 16.2 20.2v151.1c0 11.2-7.2 20.2-16.2 20.2z",
  fill: "#3f3d3c"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 100.7l63.7-83.4c3.4-4.4 10-4.4 13.3.1l62.5 83.4",
  fill: "none",
  stroke: "#3f3d3c",
  strokeWidth: 24.33,
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

var SvgArrow = function SvgArrow(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 166 300"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxNjYgMzAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNjYgMzAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojM0YzRDNDO30NCgkuc3Qxe2ZpbGw6bm9uZTtzdHJva2U6IzNGM0QzQztzdHJva2Utd2lkdGg6MjQuMzI5OTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9DQo8L3N0eWxlPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTgzLjIsMjk4LjdMODMuMiwyOTguN2MtOC45LDAtMTYuMi05LTE2LjItMjAuMlYxMjcuNGMwLTExLjEsNy4yLTIwLjIsMTYuMi0yMC4ybDAsMGM4LjksMCwxNi4yLDksMTYuMiwyMC4yDQoJdjE1MS4xQzk5LjQsMjg5LjcsOTIuMiwyOTguNyw4My4yLDI5OC43eiIvPg0KPHBhdGggY2xhc3M9InN0MSIgZD0iTTEzLjUsMTAwLjdsNjMuNy04My40YzMuNC00LjQsMTAtNC40LDEzLjMsMC4xbDYyLjUsODMuNCIvPg0KPC9zdmc+DQo=";
export { SvgArrow as ReactComponent };